function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductMaster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512.503 512.503",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M497.051 256.252c0 133.101-107.899 241-241 241-73.9 0-140.032-33.262-184.24-85.632M15.051 256.252c0-133.101 107.899-241 241-241 72.915 0 138.267 32.381 182.461 83.548",
    style: {
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#999999",
    strokeWidth: 30,
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.454,
    cy: 385.414,
    r: 34.454,
    style: {
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#999999",
    strokeWidth: 30,
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 463.049,
    cy: 122.98,
    r: 34.454,
    style: {
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#999999",
    strokeWidth: 30,
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.444 317.101V195.402l-105.393-60.849-105.394 60.849v121.699l105.394 60.849z",
    style: {
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#999999",
    strokeWidth: 30,
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m150.657 195.402 105.394 60.85 105.393-60.85M256.051 256.252V377.95",
    style: {
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#999999",
    strokeWidth: 30,
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1,
    className: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductMaster);
export default __webpack_public_path__ + "static/media/product-master.ebebfa5e03798588ff023f80a9c6f6ac.svg";
export { ForwardRef as ReactComponent };